import React from "react";
import {
  notification,
  Popconfirm,
  Select,
  Table,
  Button,
  message,
  Spin,
} from "antd";
import sualtap from "./../../../const/api";
import { SmileOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { toggleLoading } from "./../../../redux/actions";
const { Option } = Select;

const columns = [
  {
    title: "ID",
    dataIndex: "id",
  },
  {
    title: "Name - Az",
    dataIndex: "name_az",
  },
  {
    title: "Name - Es",
    dataIndex: "name_es",
  },
  {
    title: "Category",
    dataIndex: "category",
  },
  {
    title: "Əməliyyatlar",
    render: (a) => a.buttons,
  },
];

class Types extends React.Component {
  state = {
    categories: [],
    types: [],
    category_id: null,
    name_az: "",
    name_es: "",
    editingId: null,
    loading: false,
    per_page: 20,
    page: 1,
    total: 50,
  };

  cancelEdit = () => {
    this.setState({
      name_az: "",
      name_es: "",
      editingId: null,
      category_id: null,
    });
  };

  confirm = async (id) => {
    await sualtap.delete(`types/${id}`).then((res) => {
      notification.info({
        message: "Successfull",
        description: "The type is successfully deleted",
        placement: "topRight",
        icon: <SmileOutlined />,
      });
      this.fetchTypes();
    });
  };

  editType = (id) => {
    let cat = this.state.types.find((c) => c.id === id).category_id;
    this.setState({
      editingId: id,
      name_az: this.state.types.find((c) => c.id === id).name_az,
      name_es: this.state.types.find((c) => c.id === id).name_es,
      category_id: cat,
    });
  };

  cancel() {
    console.log("cancelled");
  }

  async fetchCategories() {
    await sualtap
      .get("categories", { params: { per_page: 1000 } })
      .then((res) => {
        this.setState({
          categories: res.data.data,
        });
      });
  }

  async fetchTypes() {
    await sualtap
      .get("types", {
        params: { page: this.state.page, per_page: this.state.per_page },
      })
      .then((res) => {
        this.setState({
          page: res.data.current_page,
          total: res.data.total,
          types: res.data.data.map((re) => {
            return {
              key: re.id,
              ...re,
              category:
                this.state.categories.length > 0
                  ? this.state.categories.find((c) => c.id === +re.category_id)
                      .name_az
                  : re.category_id,
              category_id: +re.category_id,
              buttons: (
                <>
                  <Button onClick={() => this.editType(re.id)}>Edit</Button>
                  <Popconfirm
                    title="Are you sure delete this type?"
                    onConfirm={() => this.confirm(re.id)}
                    onCancel={this.cancel}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button className="ml-5" danger>
                      Delete
                    </Button>
                  </Popconfirm>
                </>
              ),
            };
          }),
        });
      });
  }

  componentDidMount = async () => {
    this.props.toggleLoading(true);
    await this.fetchCategories();
    await this.fetchTypes();
    this.props.toggleLoading(false);
  };

  handleNameChange = (e, type) => {
    if (type) {
      this.setState({ name_az: e.target.value });
    } else {
      this.setState({ name_es: e.target.value });
    }
  };

  addType = async (e) => {
    e.preventDefault();
    if (
      !this.state.name_az.trim().length ||
      !this.state.name_es.trim().length ||
      this.state.category_id == null
    ) {
      message.warning("Type name and category are required");
    } else {
      this.setState({ loading: true });
      if (this.state.editingId === null) {
        await sualtap
          .post(
            "types",
            JSON.stringify({
              name_az: this.state.name_az,
              name_es: this.state.name_es,
              category_id: this.state.category_id,
            })
          )
          .then((res) => {
            message.success("Type added");
            this.fetchTypes();
            this.cancelEdit();
          })
          .finally(() => {
            this.setState({ loading: false });
          });
      } else {
        await sualtap
          .put(
            `types/${this.state.editingId}`,
            JSON.stringify({
              id: this.state.editingId,
              name_az: this.state.name_az,
              name_es: this.state.name_es,
              category_id: this.state.category_id,
            })
          )
          .then((res) => {
            message.success("Type edited");
            this.fetchTypes();
            this.cancelEdit();
          })
          .finally(() => {
            this.setState({ loading: false });
          });
      }
    }
  };

  onChange = (e) => {
    this.setState({
      category_id: e,
    });
  };

  changePage = (e) => {
    this.setState({ page: e.current, per_page: e.pageSize }, () => {
      this.fetchTypes();
    });
  };

  render() {
    return (
      <>
        <div className="b-page-top">
          <h2>Types</h2>
        </div>
        <div className="b-add-box">
          <div className="b-add-box-left">
            <Table
              columns={columns}
              dataSource={this.state.types}
              pagination={{
                pageSize: this.state.per_page,
                current: this.state.page,
                total: this.state.total,
              }}
              size="middle"
              onChange={(e) => this.changePage(e)}
            />
          </div>
          <div className="b-add-box-right">
            <form onSubmit={this.addType}>
              <input
                placeholder="Type name - az"
                value={this.state.name_az}
                onChange={(e) => this.handleNameChange(e, true)}
                className="ant-input mb-10"
                type="text"
              />
              <input
                placeholder="Type name - es"
                value={this.state.name_es}
                onChange={(e) => this.handleNameChange(e, false)}
                className="ant-input"
                type="text"
              />
              <Select
                className="b-100 mt-10 fl"
                style={{ width: "100%" }}
                placeholder="Select category"
                value={this.state.category_id}
                onChange={(e) => this.onChange(e)}
              >
                {this.state.categories.map((c, index) => {
                  return (
                    <Option value={c.id} key={index}>
                      {c.name_az} - {c.name_es}
                    </Option>
                  );
                })}
              </Select>
              <Button htmlType="submit" type="primary" className="mt-10">
                {this.state.editingId !== null ? "Edit type" : "Add new type"}
                {this.state.loading ? <Spin /> : null}
              </Button>
              {this.state.editingId !== null ? (
                <Button
                  onClick={this.cancelEdit}
                  type="primary"
                  className="mt-10 ml-5"
                >
                  Cancel edit
                </Button>
              ) : null}
            </form>
          </div>
        </div>
      </>
    );
  }
}

export default connect(null, { toggleLoading })(Types);
